export const PASSWORD_MIN_LENGTH = 8

export const validatePassword = (password) => {
  const props = {
    hasMinLength: password.length >= PASSWORD_MIN_LENGTH,
    hasUppercase: /\p{Lu}/u.test(password), // Matches any uppercase letter (Unicode-aware)
    hasLowercase: /\p{Ll}/u.test(password), // Matches any lowercase letter (Unicode-aware)
    hasNumbers: /[0-9]/.test(password), // Matches any digit
    hasSpecialChars: /[\p{P}\p{S}]/u.test(password) // Matches punctuation and symbols (Unicode-aware)
  }

  return {
    ...props,
    isValid: Object.values(props).every(val => val)
  }
}
